import React from "react";
import { Checkbox } from "@mui/material";
import { GoCheck } from "react-icons/go";
import { Stack } from "react-bootstrap";
import { FaMinus } from "react-icons/fa6";

const CustomCheckbox = React.forwardRef(({ ...rest }, ref) => (
  <Checkbox
    {...rest}
    ref={ref}
    icon={
      <Stack
        style={{
          height: "20px",
          width: "20px",
          border: "1px solid #A8A8BD",
        }}
        className="justify-content-center align-items-center"
      />
    }
    checkedIcon={
      <Stack
        style={{
          height: "20px",
          width: "20px",
          border: "1px solid #16161D",
        }}
        className="justify-content-center align-items-center"
      >
        <GoCheck color="#16161D" />
      </Stack>
    }
    indeterminateIcon={
      <Stack
        style={{
          height: "20px",
          width: "20px",
          border: "1px solid #16161D",
        }}
        className="justify-content-center align-items-center"
      >
        <FaMinus color="#16161D" />
      </Stack>
    }
    sx={{ p: 0 }}
  />
));

export default CustomCheckbox;
